import React, { useEffect, useState } from 'react';
import { Col, Form, Row, Button } from 'antd';

import { sendData } from '../../httpRequests';
import { getPharmacyId, ScheduleComponent } from '../../components/Shared';
import { DAYS } from '../../constants/Time';

export default function Schedule() {
	const [pharmacy, setPharmacy] = useState({});
	const [schedule, setSchedule] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const pharmacyId = getPharmacyId();
		if (pharmacyId) {
			const url = '/pharmacies/getPharmacyById';
			const data = {
				id: pharmacyId
			};
			sendData(url, data).then((response) => {
				const pharmacy = response['pharmacy'];
				const url = '/pharmacies/getPharmacySchedules';
				const data = {
					pharmacy_id: pharmacy.id
				};
				sendData(url, data).then((response) => {
					if (Object.keys(response).length > 0) {
						console.log(response);
					}
				});
				setPharmacy(pharmacy);
			});
		}
	}, []);

	const updatePharmacySchedule = (values) => {
		// const days = values.days;
		// let url = '';
		// let data = {};
		// if(id){
		//     url = '/pharmacies/updatePharmacySchedules';
		//     data = {
		//         id: id,
		//         pharmacy_id = getPharmacyId(),
		//         open: day.open,
		//         close: day.close
		//     }
		// }
	};

	return (
		<div>
			{Object.keys(pharmacy).length > 0 && (
				<Form layout='vertical' onFinish={updatePharmacySchedule}>
					<div>
						<h2 style={{ marginBottom: 30 }}>Pharmacy schedule</h2>
						<div style={{ padding: '0 40px' }}>
							{DAYS.map((day, index) => (
								<ScheduleComponent day={day} key={index} />
							))}
						</div>
					</div>
					<Row gutter={24} style={{ marginTop: 50 }}>
						<Col span={24}>
							<Form.Item>
								<Button
									type='primary'
									htmlType='submit'
									loading={isLoading}
									disabled={isLoading}
									style={{ borderRadius: 10, width: '100%', backgroundColor: '#128780' }}
									size='large'
								>
									Save schedule
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			)}
		</div>
	);
}
